export default __webpack_public_path__ + "static/media/debate_14.94591f63.JPG";